import {Component, OnDestroy, OnInit} from "@angular/core";
import {BaseFilterController} from "../BaseFilterController";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DictionaryService, TableService} from "@amlCore/services";
import {ClientTypeEnum} from "@amlCore/enums";
import {Unsubscribable} from "rxjs";
import { ActivatedRoute } from "@angular/router";
import {IDictItemType} from "@amlCore/interfaces";
import {Qref281fzFilter} from "../../models/qref281fzFilter.model";

@Component({
  selector: "app-281fz-list-filter",
  templateUrl: "./qref281fzListFilter.component.html"
})

export class Qref281fzListFilterComponent extends BaseFilterController implements OnInit, OnDestroy {

  public selectObj = {
    clientTypeList: [] as IDictItemType[]
  };
  ClientTypeEnum = ClientTypeEnum;
  public filterObjectModel = new Qref281fzFilter();
  placeholder = 'Поиск по ФИО, наименованию';
  clientTypeField = { // Поля для разблокировки по группе
    1: ['orgName', 'regNum'], // Юридическое лицо
    2: ['allName', 'birthDate'], // Физическое лицо
  };
  // Все поля для блокировки
  allFiled = ['orgName', 'regNum', 'allName', 'birthDate'];
  subjectTypeSub: Unsubscribable;

  constructor(private fb: FormBuilder,
              protected tableSrv: TableService,
              private dictSrv: DictionaryService,
              protected activatedRoute: ActivatedRoute) {
    super(tableSrv, activatedRoute);
  }

  ngOnInit(): void {
    this.init();
    this.dictSrv.loadTypeClient().then(result => {
      this.selectObj.clientTypeList = result.filter((item: IDictItemType) => ['1', '2'].includes(item.code));
    });
    this.subjectTypeSub = this.f('subjectType').valueChanges.subscribe(subjectType => {
      const resetValue = new Qref281fzFilter();
      resetValue.subjectType = subjectType;
      this.formModel.reset(resetValue, {emitEvent: false});
      this.allFiled.forEach(field => this.f(field).disable());
      if (subjectType) {
        this.clientTypeField[subjectType].forEach(field => this.f(field).enable());
      }
    });
  }

  /**
   * Метод создания формы
   */
  public createFormModel(): FormGroup {
    return this.fb.group(new Qref281fzFilter());
  }

  getStartFilterModel(): Qref281fzFilter {
    return {
      subjectType: '1'
    } as Qref281fzFilter;
  }

  /**
   * Описания полей
   */
  public getFilterDescription(): any {
    return {
      subjectType: 'Тип субъекта',
      recordNum: 'Номер записи',
      orgName: 'Название',
      regNum: 'Регистрационный номер',
      allName: 'ФИО',
      birthDate: 'Дата рождения'
    };
  }

  /**
   * Переопределение ngOnDestroy
   */
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subjectTypeSub.unsubscribe();
  }

}
